module.exports = __webpack_public_path__ + "media/images/campaign_explain2_SP-64501cc12f470bd07758e2a3e91f15ba.png";